module.exports = __webpack_public_path__ + "static/elevate-logo-f0311327d447fa4105cef7be05f4d66d.png";